<div class="overlay"></div>
<div class="modal">
    <div class="modal-header" *ngIf="data?.title">
        <h2 class="modal-title">{{ data.title }}</h2>
    </div>
    <div class="modal-body" [innerHTML]="data?.content"></div>
    <div class="modal-footer">
        <button nz-button type="button" class="mr-2" (click)="close(false)">
            {{ data?.cancelText || ('common.cancel' | translate) }}
        </button>
        <button nz-button type="button" nzType="primary" [nzDanger]="data?.destructive" (click)="close(true)">
            {{ data?.confirmText || (data?.destructive ? ('common.delete' | translate) : ('common.confirm' | translate)) }}
        </button>
    </div>
</div>
